import ExcelJS from 'exceljs';

export function downloadReport(data, headerMap, fileName) {

  const mapHeaders = (obj) =>
    Object.keys(headerMap).reduce((newObj, key) => {
      if (obj.hasOwnProperty(key)) {
        const newKey = headerMap[key];
        newObj[newKey] = obj[key] === null ? '-' : obj[key];
      }
      return newObj;
    }, {});

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Sheet1');

  const headers = Object.keys(mapHeaders(data[0]));
  worksheet.addRow(headers);

  for (const row of data) {
    const values = headers.map((header) => mapHeaders(row)[header]);
    worksheet.addRow(values);
  }

  // Create a Blob with the Excel data
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    // Create a link and trigger the download
    const a = document.createElement('a');
    const url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName + '.xlsx';
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  });
}
